import { useValidateStep } from '@/components/forms/useValidateStep';
import { type ReplaceInPersonFormState, StepMap, steps } from '../../constants';
import { useState } from 'react';
import { isValid } from './state';
import { Step } from '@/components/forms/Step';
import { Default } from './components/Default';
import { handleNext } from './routing';
import { ReplaceInPersonFormActionMap } from '../../reducer';
import { SubStepsWrapper } from './components/SubStepsWrapper';

export interface PictureStepProps {
	testId?: string;
}

export type SubStepOpts = 'default' | 'upload' | 'model-number' | 'type-size';

const PictureStep = (props: PictureStepProps) => {
	const { testId = 'PictureStep' } = props;
	useValidateStep<
		StepMap,
		ReplaceInPersonFormState,
		ReplaceInPersonFormActionMap
	>(isValid, steps.Picture);

	const [showComponent, setShowComponent] = useState<SubStepOpts>('default');
	const handleClick = (show: SubStepOpts) => {
		setShowComponent(show);
	};

	return (
		<div data-testid={testId}>
			<Step<StepMap, ReplaceInPersonFormState, ReplaceInPersonFormActionMap>
				name={steps.Picture}
				onNext={handleNext}
			>
				{showComponent === 'default' && <Default handleClick={handleClick} />}

				{showComponent !== 'default' && (
					<SubStepsWrapper
						handleClick={handleClick}
						showComponent={showComponent}
					/>
				)}
			</Step>
		</div>
	);
};

export default PictureStep;
